import { render } from "./AnswerPractice.vue?vue&type=template&id=5637df47&scoped=true"
import script from "./AnswerPractice.vue?vue&type=script&lang=js"
export * from "./AnswerPractice.vue?vue&type=script&lang=js"

import "./AnswerPractice.vue?vue&type=style&index=0&id=5637df47&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5637df47"]])

export default __exports__